import { t } from 'i18next';
import { MerchantInfo } from 'services/merchants/types';

import RoutePath from 'router/path';

import { SettingsFormField } from '../../types';

export const FORM_FIELDS: Record<string, keyof MerchantInfo | string> = {
  ACCOUNT_ID: 'uuid',
  ACCOUNT_NAME: 'name',
  MERCHANT_ID: 'shift4MerchantId',
  GROUP_ACCOUNT: 'groupAccount',
  BRIDGE_CUSTOMER_ID: 'bridgeCustomerId',
  MESH_SUBCLIENT_ID: 'meshSubclientId',
  PROCESSING_FEE: 'processingFee',
  WEBHOOK_URL: 'webhookUrl',
  STATUS: 'status',
  KYC_STATUS: 'kyc',
  MAIN_FIAT_CURRENCY: 'mainFiatCurrency',
  UPDATE_KYB_INFORMATION: 'updateKybInformation',
  KYB_ERROR: 'kybError',
};

export const KEYS = {
  ROUTE_MATCH: `${RoutePath.Pwc.Accounts.ById}/:route`,
  ROUTE_MATCH_ID: `${RoutePath.Pwc.Accounts.ById}/:route`,
};

export const LABELS = {
  PANEL_TITLE: ['page.merchantSettings.general.title', 'General'],
  SAVE_BUTTON_LABEL: ['page.merchantSettings.general.save', 'Save'],
  CANCEL_BUTTON_LABEL: ['page.merchantSettings.general.cancel', 'Cancel'],
  FORM_FIELDS: {
    ACCOUNT_ID: ['page.merchantSettings.general.form.accountId', 'Account ID'],
    ACCOUNT_NAME: ['page.merchantSettings.general.form.accountName', 'Account Name'],
    GROUP_ACCOUNT: ['page.merchantSettings.general.form.groupAccount', 'Group Account'],
    MERCHANT_ID: ['page.merchantSettings.general.form.merchantId', 'Shift4 Merchant ID'],
    WEBHOOK_URL: ['page.merchantSettings.general.form.webhookURL', 'Webhook URL'],
    PROCESSING_FEE: ['page.merchantSettings.general.form.processingFee', 'Processing Fee %'],
    STATUS: ['page.merchantSettings.general.form.status', 'Status'],
    KYC_STATUS: ['page.merchantSettings.general.form.kycStatus', 'Bridge KYC Status'],
    KYB_ERROR: ['page.merchantSettings.general.form.kybError', 'Error'],
    CHANGE_STATUS: ['page.merchantSettings.general.form.changeStatus', 'Change Status'],
    BRIDGE_CUSTOMER_ID: ['page.merchantSettings.general.form.bridgeCustomerId', 'Bridge Customer ID'],
    MESH_SUBCLIENT_ID: ['page.merchantSettings.general.form.meshSubclientId', 'Mesh Subclient ID'],
    MAIN_FIAT_CURRENCY: ['page.merchantSettings.general.form.mainFiatCurrency', 'Fiat Payout Currency'],
    UPDATE_KYB_INFORMATION: ['page.merchantSettings.general.form.updateKybInformation', 'Bridge KYB Information'],
    PLACEHOLDERS: {
      ACCOUNT_ID: ['page.merchantSettings.general.form.accountId.placeholder', 'Account ID'],
      ACCOUNT_NAME: ['page.merchantSettings.general.form.accountName.placeholder', 'Account Name'],
      MESH_SUBCLIENT_ID: ['page.merchantSettings.general.form.meshSubclientId.placeholder', 'Enter Mesh Subclient ID'],
      MERCHANT_ID: ['page.merchantSettings.general.form.merchantId.placeholder', 'Enter Shift4 Merchant ID'],
      WEBHOOK_URL: ['page.merchantSettings.general.form.webhookURL.placeholder', 'https://'],
      PROCESSING_FEE: ['page.merchantSettings.general.form.processingFee.placeholder', 'Processing Fee %'],
    },
    VALUES: {
      PROCESSING_FEE: ['page.merchantSettings.general.form.value.processingFee', '{{fee}}%'],
      MERCHANT_STATUS_ACTIVE: ['page.merchantSettings.general.form.value.merchantStatusActive', 'Active'],
      MERCHANT_STATUS_DEACTIVATED: ['page.merchantSettings.general.form.value.merchantStatusDeactivated', 'Deactivated'],
      MERCHANT_STATUS_ONBOARDING: ['page.merchantSettings.general.form.value.merchantStatusOnboarding', 'Onboarding'],
      MERCHANT_STATUS_INACTIVE: ['page.merchantSettings.general.form.value.merchantStatusInactive', 'Inactive'],
    },
    ACTIONS: {
      DEACTIVATE: ['page.merchantSettings.general.form.action.deactivate', 'Deactivate'],
      ACTIVATE: ['page.merchantSettings.general.form.action.activate', 'Activate'],
      UPDATE: ['page.merchantSettings.general.form.action.update', 'Update'],
      UPDATE_KYB: ['page.merchantSettings.general.form.action.updateKyb', 'Update KYB'],
      UPDATE_UBO: ['page.merchantSettings.general.form.action.updateUbo', 'Update UBO'],
    },
    MESSAGES: {
      YES: ['page.merchantSettings.general.form.messages.yes', 'Yes'],
      NO: ['page.merchantSettings.general.form.messages.no', 'No'],
    },
  },
  ADORNMENTS: {
    PERCENT: '%',
    HTTPS: 'https://',
  },
  MODAL: {
    TITLE: ['page.merchantSettings.general.modal.title', 'Suspend Account'],
    CONFIRM: ['page.merchantSettings.general.modal.confirm', 'Confirm'],
    CANCEL: ['page.merchantSettings.general.modal.cancel', 'Cancel'],
    HEADER: ['page.merchantSettings.general.modal.header', 'Are you sure?'],
    CONFIRM_CHOICE_IMAGE_ALT: ['page.merchantSettings.general.modal.confirmChoiceImageAlt', 'Confirm choice image'],
    DEACTIVATION_MESSAGE: ['page.merchantSettings.general.modal.deactivationMessage', 'The account <b>{{name}}</b> will be deactivated.'],
  },
};

export const formFields: SettingsFormField[] = [
  {
    key: FORM_FIELDS.ACCOUNT_ID,
    label: t(LABELS.FORM_FIELDS.ACCOUNT_ID),
  },
  {
    key: FORM_FIELDS.ACCOUNT_NAME,
    label: t(LABELS.FORM_FIELDS.ACCOUNT_NAME),
  },
  {
    key: FORM_FIELDS.MERCHANT_ID,
    label: t(LABELS.FORM_FIELDS.MERCHANT_ID),
  },
  {
    key: FORM_FIELDS.BRIDGE_CUSTOMER_ID,
    label: t(LABELS.FORM_FIELDS.BRIDGE_CUSTOMER_ID),
  },
  {
    key: FORM_FIELDS.MESH_SUBCLIENT_ID,
    label: t(LABELS.FORM_FIELDS.MESH_SUBCLIENT_ID),
  },
  {
    key: FORM_FIELDS.WEBHOOK_URL,
    label: t(LABELS.FORM_FIELDS.WEBHOOK_URL),
  },
  {
    key: FORM_FIELDS.PROCESSING_FEE,
    label: t(LABELS.FORM_FIELDS.PROCESSING_FEE),
  },
  {
    key: FORM_FIELDS.STATUS,
    label: t(LABELS.FORM_FIELDS.STATUS),
  },
  {
    key: FORM_FIELDS.CHANGE_STATUS,
    label: t(LABELS.FORM_FIELDS.CHANGE_STATUS),
  },
];
